export const COMMISSION_POPUP_MODE = {
    VIEW: 1,
    ADD: 2
}

export const COMMISSION_ADD_FIELDS = {
    CURRENCY_CODE: "currencyCode",
    COMMISSION_TYPE: "type",
    START_DATE: "startDate"
}